import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './enterprise.intl.json';

export const useEnterpriseIntl = () => useIntlModule(messages);
